import ButtonNew from 'root/src/client/web/base/ButtonNew';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSignInWithProvider } from 'root/src/client/web/auth/hooks/useSignInWithProvider';
import { PlatformIcon } from 'root/src/client/web/base/CustomButton/PlatformIcon';
import { providerToPlatform } from 'root/src/shared/util/platformHelpers';
import { useSignInWithProviderModal } from 'root/src/client/web/auth/hooks/useSignInWithProviderModal';
const SignInWithProviderModal = ({ props }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { onSignIn, providerLabel, provider, } = useSignInWithProvider({
        provider: props.item.provider,
        isLinking: (_a = props.item) === null || _a === void 0 ? void 0 : _a.isLinking,
        scopeSet: (_b = props.item) === null || _b === void 0 ? void 0 : _b.scopeSet,
        popup: ((_c = props.item) === null || _c === void 0 ? void 0 : _c.popup) || false,
        popupOptions: ((_d = props.item) === null || _d === void 0 ? void 0 : _d.popup) ? (_e = props.item) === null || _e === void 0 ? void 0 : _e.popupOptions : undefined,
    });
    const { label, header } = useSignInWithProviderModal({
        provider: props.item.provider,
        label: (_f = props.item) === null || _f === void 0 ? void 0 : _f.label,
        header: (_g = props.item) === null || _g === void 0 ? void 0 : _g.header,
    });
    return (<div className="flex flex-col justify-center gap-8 p-4">
			<h1 className="text-3xl font-mono uppercase text-center font-bold">{header}</h1>
			<FontAwesomeIcon size="5x" icon={faCircleInfo} className="text-3xl text-center"/>
			<div className="flex flex-col gap-4">
				<p className="text-light-4 text-center break-words">{label}</p>
				<ButtonNew onClick={onSignIn}>
					<PlatformIcon platform={providerToPlatform(provider)} size="lg"/>
					<span className="mx-2">Sign in with {providerLabel}</span>
				</ButtonNew>
			</div>
		</div>);
};
export default SignInWithProviderModal;
